import React from 'react'
import { useRouter } from 'next/router'
import queryString from 'query-string'

import PhatButton from 'components/formElements/PhatButton'
import PhatDropdown from 'components/formElements/PhatDropdown'

import styles from './sortingDropdown.module.scss'

type QueryParams = { orderBy?: string }

type Props = {
  defaultOrderBy?: string
  defaultDescending?: boolean
  useCreatedAt?: boolean
  usePoints?: boolean
}

const SortingDropdown = ({ defaultOrderBy = 'updatedAt', defaultDescending = true, useCreatedAt = false }: Props) => {
  const router = useRouter()
  const params = router.query as QueryParams // There may be more than just order by on the URL, so be sure to always update the URL with all of it's params

  const defaultOrderByValue = defaultDescending ? `-${defaultOrderBy}` : defaultOrderBy

  const { orderBy = defaultOrderByValue } = params

  const isDescending = orderBy[0] === '-'
  const orderByValue = isDescending ? orderBy.substring(1) : orderBy

  const handleToggleDescending = () => handleSetOrderBy(orderByValue, !isDescending)

  const handleSetOrderBy = (key: string, overrideDescending?: boolean) => {
    const newOrderBy = overrideDescending ?? isDescending ? `-${key}` : key

    const existingUrl = router.asPath.split('?')[0]
    const existingParams = queryString.parse(router.asPath.split('?')[1] || '')

    router.push(`${existingUrl}?${queryString.stringify({ ...existingParams, page: '1', orderBy: newOrderBy })}`)
  }

  return (
    <div className={styles.container}>
      <PhatButton
        icon={isDescending ? 'sort content descending' : 'sort content ascending'}
        onClick={handleToggleDescending}
      />
      <PhatDropdown
        value={orderByValue}
        options={[
          { label: 'Most recent', id: 'updatedAt', onClick: () => handleSetOrderBy('updatedAt'), hidden: useCreatedAt },
          { label: 'Created at', id: 'createdAt', onClick: () => handleSetOrderBy('createdAt'), hidden: !useCreatedAt },
          { label: 'Points', id: 'points', onClick: () => handleSetOrderBy('points') },
        ]}
      />
    </div>
  )
}

export default SortingDropdown
